var map = {
	"./collage1.mp4": "siLZ",
	"./collage2.mp4": "b20Y",
	"./collage3.mp4": "sia5",
	"./collage4.mp4": "43rq",
	"./explanation-1.mp4": "CX43",
	"./explanation-2.mp4": "aD5l"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Lfhv";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos ^\.\/.*$
// module id = Lfhv
// module chunks = 1